import {
  GET_LAYOUT_MAP,
  SET_LAYOUT_MAP,
} from "../constants/layout-map-constants";

const initialState = {
  status: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LAYOUT_MAP:
      const { data } = action;
      return { ...state, data };
    default:
      return state;
  }
};
